<template>
    <div class=" w-full border-1 border-gray-700 p-3">
        <div class="chart-inner-headline pl-6 pb-4">{{$t('pages.controlpanel.index.controls.quantity_sold_title')}}</div>
        <div class="block md:flex">
            <div class="w-full md:w-6/12">
                <QuantitySoldBar
                    :data="this.dataSold"
                    :labels="[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23]"
                    :chart-label="$t('pages.controlpanel.index.controls.quantity_sold_title')"
                    :width="200"
                    :height="200"
                ></QuantitySoldBar>
            </div>
            <div class="w-full md:w-6/12 flex mt-8 md:mt-0">
                <div class="w-3/5">
                    <QuantitySoldPie
                        :label-sold="this.$t('pages.controlpanel.index.controls.quantity_sold')"
                        :label-pending="this.$t('pages.controlpanel.index.controls.quantity_pending')"
                        :label-available="this.$t('pages.controlpanel.index.controls.quantity_available')"
                        :amount-sold="sold"
                        :amount-pending="pending"
                        :amount-available="available"
                        :width="'auto'"
                        :height="'auto'"
                        :options="{
                            responsive: true,
                            maintainAspectRatio: false,
                            legend: {
                                display: false
                            }
                        }"/>
                </div>

                <div class="w-2/5">
                    <div class="pb-4 items-left px-3">
                        <div class="text-2xl">{{sold}}</div>
                        <div class="text-xs font-bold">{{$t('pages.controlpanel.index.controls.quantity_sold')}}</div>
                    </div>
                    <div class="pb-4 items-left px-3">
                        <div class="text-2xl">{{pending}}</div>
                        <div class="text-xs font-bold">{{$t('pages.controlpanel.index.controls.quantity_pending')}}</div>
                    </div>
                    <div class="items-left px-3">
                        <div class="text-2xl">{{available}}</div>
                        <div class="text-xs font-bold">{{$t('pages.controlpanel.index.controls.quantity_available')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { Link } from '@inertiajs/vue2';
import Icon from '@/Shared/Icon';
import QuantitySoldBar from "../Charts/QuantitySoldBar";
import QuantitySoldPie from "../Charts/QuantitySoldPie";


export default {
    components: {
        QuantitySoldPie,
        QuantitySoldBar,
        Link,
        Icon
    },
    props: {
        sold: Number,
        pending: Number,
        available: Number,
        dataSold: Array
    }
}
</script>
